import { useThemeContext } from '@honda-canada/design-system-react';
import { ACURA_THEME_NAME } from '../../utils/constants';
const useSummaryAlertCtaColors = () => {
    const ctaColors = { text: '', icon: '' };
    const { colors, name: themeName } = useThemeContext();
    switch (themeName) {
        case ACURA_THEME_NAME:
            ctaColors.icon = colors.blues[1];
            ctaColors.text = colors.blues[1];
            break;
        default:
            ctaColors.icon = colors.primary;
            ctaColors.text = colors.black;
            break;
    }
    return ctaColors;
};
export default useSummaryAlertCtaColors;
